import React from "react";
import { useNavigate } from 'react-router-dom';
import ListProxyExpiredComponent from "../../../components/Customer/proxies/ListProxyExpiredComponent";

const ListProxyExpirePage = () => {
    const navigate = useNavigate();

    let redirectChangeUser = (listVps) => {
        navigate('/dich-vu-proxy/chuyen-khach-hang.html?' + listVps);
    }

    return <ListProxyExpiredComponent
        redirectChangeUser={ (listVps) => redirectChangeUser(listVps) }
    />

}

export default ListProxyExpirePage;